import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { AcademicRoute } from "./routes";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "academicAccountPortal",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "admin-home" */ "./components/AcademicAccountPortal"
      ),
      import(
        /* webpackChunkName: "administrator" */ "Administrator/modules/AdministratorModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;

      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "administrator",
        reducer,
      });

      return component;
    })
  ),
  childRoutes: [AcademicRoute(store)],
});
